const isTopNode = (j, path) => j.Program.check(path.parent.value);

export { isTopNode };
